import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const HomeIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>);
const ListIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none"/><circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none"/></svg>);
const StarIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const StatsIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>);

const NAV_ITEMS = [
  { id: 'home', label: 'Home', path: '/', icon: <HomeIcon/> },
  { id: 'exercises', label: 'Exercises', path: '/exercises', icon: <ListIcon/> },
  { id: 'myexercises', label: 'My Studies', path: '/my-exercises', icon: <StarIcon/> },
  { id: 'stats', label: 'Stats', path: '/stats', icon: <StatsIcon/> },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(false);
  
  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 900);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (isDesktop) return null;

  const activeId = location.pathname === '/' ? 'home'
    : location.pathname.startsWith('/exercises') ? 'exercises'
    : location.pathname.startsWith('/my-exercises') ? 'myexercises'
    : location.pathname.startsWith('/stats') ? 'stats'
    : 'home';

  return (
    <div className="bottom-nav" style={{ position:'fixed', bottom:0, left:'50%', transform:'translateX(-50%)', width:'100%', maxWidth:'var(--app-width, 860px)', background:'#0E0C0A', borderTop:'1px solid #1E1C18', padding:'10px 0 20px', display:'flex', justifyContent:'space-around', zIndex:100 }}>
      {NAV_ITEMS.map(item => (
        <button key={item.id} onClick={() => navigate(item.path)}
          style={{ background:'transparent', border:'none', cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:4, color: activeId===item.id?'#FF5500':'#4A4640', transition:'all 0.15s' }}>
          {item.icon}
          <span style={{ fontSize:10, fontWeight:700, fontFamily:"'Barlow Condensed', sans-serif", letterSpacing:1 }}>
            {item.label.toUpperCase()}
          </span>
          {activeId===item.id && <div style={{ width:4, height:4, borderRadius:'50%', background:'#FF5500', marginTop:-2 }}/>}
        </button>
      ))}
    </div>
  );
}
